import React from "react";
import Dialog from "@material-ui/core/Dialog";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DatePicker from "react-datepicker";
import t from "../../../../helpers/t";
import { Biscuit } from "../../../../../utils";
import de from "date-fns/locale/de";
import en from "date-fns/locale/en-GB";
import fr from "date-fns/locale/fr";
const ScheduleDialog = ({
  handleToggleScheduleDialog,
  handleChangeCheckRepeat,
  handleChangeSelectDatetime,
  onChangeForm,
  onSubmit,
  toggleDialogSchedule,
  formError,
  message,
  itemState,
  startDate,
  checked,
}) => {
  const dateLocale =
    Biscuit.get("user.lang").indexOf("de") >= 0
      ? de
      : Biscuit.get("user.lang").indexOf("fr") >= 0
        ? fr
        : en;
  const CustomSelectDateInput = React.forwardRef((props, ref) => {
    return (
      <div>
        <div className="react-datepicker-wrapper">
          <div className="react-datepicker__input-container">
            <i className="fi fi-calendar" onClick={props.onClick}></i>
            <span role="alert" aria-live="polite" className="react-datepicker__aria-live"></span>
            <input
              type="text"
              className=""
              value={props.value || props.placeholder}
              onChange={props.onChange}
              onClick={props.onClick}
              ref={ref}
            />
          </div>
        </div>
      </div>
    );
  });

  const CustomSelectTimeInput = React.forwardRef((props, ref) => {
    return (
      <div>
        <div className="react-datepicker-wrapper">
          <div className="react-datepicker__input-container">
            <i className="fi fi-clock" onClick={props.onClick}></i>
            <span role="alert" aria-live="polite" className="react-datepicker__aria-live"></span>
            <input
              type="text"
              className=""
              value={props.value || props.placeholder}
              onClick={props.onClick}
              onChange={props.onChange}
              ref={ref}
            />
          </div>
        </div>
      </div>
    );
  });

  return (
    <Dialog
      onClose={handleToggleScheduleDialog}
      aria-labelledby="simple-dialog-title"
      open={toggleDialogSchedule}
      name="schedule-dialog"
      id="schedule-dialog"
    >
      <header className="inb-schedule-message-header off-canvas-schedule__header">
        <h1 className="inb-dialog-title">{t("pick date & time")}</h1>
        <button
          onClick={handleToggleScheduleDialog}
          type="button"
          id="inb-schedule-dialog-close-button"
          className="button hollow secondary right button-close-schedule-dialog round"
          title={t("close schedule dialog")}
        >
          <i className="fi fi-x"></i>
        </button>
      </header>
      <div className="schedule-dialog-body row">
        <div className="small-6 select-date-schedule">
          <DatePicker
            key={"inb-sidebar-filter-"}
            className="noBorders-noBackground"
            customInput={<CustomSelectDateInput />}
            dateFormat="dd/MM/y"
            minDate={new Date()}
            selected={startDate}
            onChange={handleChangeSelectDatetime}
            onKeyDown={(e) => {
              if (e.keyCode === 8) e.preventDefault();
            }}
            locale={dateLocale}
          />
        </div>
        <div className="small-6 select-time-schedule">
          <DatePicker
            selected={startDate}
            onChange={handleChangeSelectDatetime}
            customInput={<CustomSelectTimeInput />}
            minDate={new Date()}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            locale={dateLocale}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="HH:mm aa"
          />
        </div>
        <div className="medium-12 small-12 repeate-schedule__checkbox">
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                name="checkRepeatSchedule"
                onChange={handleChangeCheckRepeat}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label={t("repeat")}
          />
        </div>
        {checked && (
          <div className="medium-12 small-12 recurrence-schedule__message">
            <div
              className={
                dateLocale === de || dateLocale === fr ? "medium-4 small-5" : "medium-3 small-5"
              }
            >
              <label>{t("repeat every")}</label>
            </div>
            <div className="medium-3 small-3">
              <input
                type="number"
                min="1"
                value={
                  message.schedule_recurrence_number ? message.schedule_recurrence_number : "1"
                }
                name="schedule_recurrence_number"
                id="schedule_recurrence_number"
                onChange={onChangeForm}
              />
              <span className="help-text">
                {typeof formError.schedule_recurrence_number !== "undefined"
                  ? t(formError.schedule_recurrence_number)
                  : ""}
              </span>
            </div>
            <div className="medium-5 small-4">
              <select
                id="select-recurrence-time"
                type="text"
                className="form-control"
                name="schedule_recurrence"
                onChange={onChangeForm}
                autoComplete="false"
                value={message.schedule_recurrence ? message.schedule_recurrence : "day"}
              >
                <option value="day">{t("day")}</option>
                <option value="week">{t("week")}</option>
                <option value="month">{t("month")}</option>
                <option value="year">{t("year")}</option>
              </select>
              <span className="help-text">
                {typeof formError.schedule_recurrence !== "undefined"
                  ? t(formError.schedule_recurrence)
                  : ""}
              </span>
            </div>
          </div>
        )}
        <div className="medium-12 small-12 off-canvas__actions column schedule-message-actions">
          <button
            type="submit"
            className="button medium button-cancel-schedule round"
            title={t("cancel", null, "capital")}
            onClick={handleToggleScheduleDialog}
          >
            <span>{t("cancel")}</span>
          </button>
          <button
            type="submit"
            className="button medium button-schedule-send round"
            title={t("schedule send", null, "capital")}
            onClick={() => onSubmit("scheduled")}
          >
            {itemState != "scheduling" && <span>{t("schedule send")}</span>}
            {itemState == "scheduling" && (
              <span>
                <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                {t("schedule send")}
              </span>
            )}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ScheduleDialog;
